import { lazy } from 'react';
import { FormLoadingOverlay } from '../forms/components/FormLoadingOverlay/FormLoadingOverlay';

const FETCH_RETRY_LIMIT = 3;
const CHUNK_RELOAD_KEY = 'CHUNK_RELOAD_KEY';
const RELOAD_RETRY_TIMEOUT = 30_000;

export const lazyCustom = importHandler =>
    lazy(async () => {
        let retryCounter = FETCH_RETRY_LIMIT;
        let forwardedError;

        while (retryCounter) {
            try {
                const loadedChunk = await importHandler();

                return loadedChunk;
            } catch (error) {
                retryCounter--;
                forwardedError = error;
            }
        }

        if (Date.now() - Number.parseInt(localStorage.getItem(CHUNK_RELOAD_KEY) || '0') > RELOAD_RETRY_TIMEOUT) {
            localStorage.setItem(CHUNK_RELOAD_KEY, Date.now());
            window.location.reload();
            return { default: FormLoadingOverlay };
        }

        throw forwardedError;
    });
